/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroups,
    GetProductCategories,
    GetFactoriesByGroupID,
    GetAllFactoriesByFactoryType,
    GetProductsByFactoryIDProductcatogeryID,
    GetStockBalanceReportData,
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetAllFactoriesByFactoryType(groupID, operationEntityTypeID) {
    const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByFactoryType', 'groupID=' + parseInt(groupID) + '&factoryType=' + operationEntityTypeID);
    return response.data;
}

async function GetProductCategories() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductCategoryID', 'factoryID=' + factoryID + '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetStockBalanceReportData(model) {
    const response = await CommonPost('/api/StockBalanceReport/GetStockBalanceReportData', null, model);
    return response.data;
}



